@if (view$ | async; as view) {
    <div class="container-fluid my-3 masonry">
        @if (
            view.buildingInfo.buildingServices.includes(buildingServices.EVENTS_AGENTS_AND_ALARMS)
        ) {
            <app-event-alarms></app-event-alarms>
        }

        @if (view.buildingInfo.buildingServices.includes(buildingServices.REMOTE_READING_DATA)) {
            <app-readings
                [meter]="view.meterData"
                [buildingNo]="view.buildingInfo.building.buildingNo"></app-readings>
        }

        <app-meter-and-system-information
            [meterData]="view.meterData"></app-meter-and-system-information>
        @if (
            view.meterData.geoLocation.longitude != null &&
            view.meterData.geoLocation.latitude != null &&
            view.buildingInfo.buildingServices.includes(buildingServices.MAP_OF_DEVICES)
        ) {
            <app-meter-map
                [longitude]="view.meterData.geoLocation.longitude"
                [latitude]="view.meterData.geoLocation.latitude">
            </app-meter-map>
        }
        @if (
            view.meterPhotos.length > 0 &&
            view.buildingInfo.buildingServices.includes(buildingServices.METER_PHOTO)
        ) {
            <app-gallery [webArchiveDocuments]="view.meterPhotos"></app-gallery>
        }
    </div>
} @else {
    <app-load />
}
